"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
var dom_helpers_1 = require("../../util/dom-helpers");
function ownerDocument(componentOrElement) {
    return dom_helpers_1.ownerDocument(ReactDOM.findDOMNode(componentOrElement));
}
exports.ownerDocument = ownerDocument;
